import AlertAnimation from './AlertAnimation';

export default AlertAnimation;
